import React, { useState, useEffect } from 'react'
import { getRequest } from '../../../apis/requestsApi'
import { useNavigate, useParams } from 'react-router-dom'
import SubscriptionInfo from '../Payment/SubscriptionInfo'
import Webcame from './webCam'
import SuccessKyc from './SuccessKyc'
const Kyc = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [type, setType] = useState(false)
  const { slug } = useParams()

  useEffect(() => {
    getData()
  }, [])
  const getData = async () => {
    try {
      const res = await getRequest(slug)
      setData(res.result)
      setLoading(false)
    } catch (error) {
      setError(true)
      setLoading(false)
    }
  }
  return (
    <>
      <div className='main-wrapper'>
        <div className=''>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className='content container-fluid'>
              {error ? (
                <h3>URL is invalid</h3>
              ) : (
                <div>
                  <h3 className='mt-5'>Kyc</h3>
                  <div>
                    <SubscriptionInfo subDetails={data.subscriptionInfo} />
                    {type == 'Camera' && <Webcame setSuccess={setType} />}
                    {type == 'Success' && <SuccessKyc />}
                    {!type && (
                      <div>
                        <img
                          src='https://uqudo.com/wp-content/uploads/2022/08/Types-of-KYC.jpg'
                          style={{ maxWidth: 800 }}
                        />
                        <br />
                        <br />
                        <div className='mt-3 mb-5'>
                          <button
                            className='btn btn-primary mb-3'
                            onClick={() => setType('Camera')}
                          >
                            Start KYC Process
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Kyc
